import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
): {
  total: number;
  archivedTotal: number;
  homecare: number;
  archivedHomecare: number;
  teleconsultation: number;
  archivedTeleconsultation: number;
} | null => {
  //   console.log(res.data);

  if (Object.keys(res.data).length) {
    const {
      total_archived,
      total_active,
      archived_homecare,
      active_homecare,
      archived_teleconsultation,
      active_teleconsultation,
    } = res.data.data;
    return {
      total: total_active,
      archivedTotal: total_archived,
      archivedHomecare: archived_homecare,
      homecare: active_homecare,
      archivedTeleconsultation: archived_teleconsultation,
      teleconsultation: active_teleconsultation,
    };
  }

  return null;
};

export const useGetTotalConsultations = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.totalConsultationsWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/consultations/summary", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            staff_id: userId,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Total consultations]", res);
      handleErrors(res, "query");
    },
  });
};
